import { useSessionStorage } from "../../../hooks/useSessionStorage.js";
import { useTabsState } from "../../../hooks/useTabsState.js";
import { useLocationContext } from "../../Locations/contexts/LocationContext.js";
import { ServicePeriodHistoryCalendar } from "./ServicePeriodHistoryCalendar.js";
import { ServicePeriodHistoryList } from "./ServicePeriodHistoryList.js";
import { ServicePeriodNowList } from "./ServicePeriodNowList.js";
import { ServicePeriodSchedulesList } from "./ServicePeriodSchedulesList.js";
import "react";
import { Icon, SegmentedControl, Tabs } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdCalendarMonth, MdViewList } from "react-icons/md";
//#region src/modules/ServicePeriods/location-panel/LocationServicePeriodsPanel.tsx
var DEFAULT_TAB_TITLES = {
	now: "Now",
	past: "Past",
	schedules: "Schedules"
};
var DEFAULT_TAB_ORDER = [
	"now",
	"past",
	"schedules"
];
function LocationServicePeriodsPanel({ actions, defaultTab = "now", onEditSchedule, persistKey, tabOrder = DEFAULT_TAB_ORDER, tabTitles }) {
	const { locationId } = useLocationContext(true);
	const titles = {
		...DEFAULT_TAB_TITLES,
		...tabTitles
	};
	const [tab, setTab] = useTabsState(persistKey ?? `locsvcperiods_${locationId}`, defaultTab);
	const [historyView, setHistoryView] = useSessionStorage(`${persistKey ?? `locsvcperiods_${locationId}`}_historyview`, "list");
	return /* @__PURE__ */ jsxs("div", {
		className: "flex flex-col",
		children: [
			/* @__PURE__ */ jsxs("div", {
				className: "inline-flex w-full items-center justify-between",
				children: [/* @__PURE__ */ jsx(Tabs, {
					currentKey: tab,
					initialTabKey: tab,
					onTabClick: (tabKey) => setTab(tabKey),
					pills: true,
					children: tabOrder.map((tabKey) => /* @__PURE__ */ jsx(Tabs.Tab, {
						tabKey,
						title: titles[tabKey]
					}, tabKey))
				}), /* @__PURE__ */ jsxs("div", {
					className: "gap-sm inline-flex items-center",
					children: [tab === "past" && /* @__PURE__ */ jsxs(SegmentedControl, {
						onChangeValue: setHistoryView,
						size: "sm",
						value: historyView,
						children: [/* @__PURE__ */ jsxs(SegmentedControl.Segment, {
							value: "list",
							children: [/* @__PURE__ */ jsx(Icon, {
								className: "mr-xxs",
								Icon: MdViewList,
								size: "sm"
							}), "List"]
						}), /* @__PURE__ */ jsxs(SegmentedControl.Segment, {
							value: "calendar",
							children: [/* @__PURE__ */ jsx(Icon, {
								className: "mr-xxs",
								Icon: MdCalendarMonth,
								size: "sm"
							}), "Calendar"]
						})]
					}), actions]
				})]
			}),
			tab === "now" && /* @__PURE__ */ jsx(ServicePeriodNowList, {}),
			tab === "past" && historyView === "list" && /* @__PURE__ */ jsx(ServicePeriodHistoryList, {}),
			tab === "past" && historyView === "calendar" && /* @__PURE__ */ jsx(ServicePeriodHistoryCalendar, {}),
			tab === "schedules" && /* @__PURE__ */ jsx(ServicePeriodSchedulesList, { onEditSchedule })
		]
	});
}
//#endregion
export { LocationServicePeriodsPanel };

//# sourceMappingURL=LocationServicePeriodsPanel.js.map